
/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { toast } from 'react-toastify';
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG, TOKEN_SHOP } from "framework/store/constants";
import http from 'utilities/http';
import Switch from "react-switch";
import { isEmpty } from "lodash";
import { Loader } from "components/loader";

export default function HoSo({ user }) {
    const [userTemp, setUserTemp] = useState({});
    const [listSetting, setListSetting] = useState([]);
    const [loading, setLoading] = useState(false);

    const [state, _setState] = useState({
        notifications: true,
        announcementEventsBenefits: true,
        viaApp: true,
        serviceNotice: true,
        newPostFromFollowed: true,
        myPostInteraction: true,
        myPostComment: true,
        taggedMe: true,
        likedMe: true,
        newFollowMe: true,
        meSetting: [],
        allSetting: []
    });
    const setState = (_state = {}) => {
        _setState({
            ...state,
            ..._state
        });
    };

    const getAllSetting = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) return;
        const resAll = await http('community/me/notification/types', {}, { token: 'Bearer ' + getCookie(TOKEN_CONGDONG) }, 'v2');
        setState({allSetting: resAll.data});
    };

    const getMeSetting = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) return;
        let resUser = [];
        resUser = await http('community/me/notification/settings', {}, { token: 'Bearer ' + getCookie(TOKEN_CONGDONG) }, 'v2');

        if (isEmpty(resUser.data) || resUser.data.length != state.allSetting.length) {
            const body = state.allSetting.map(setting => {
                return {
                    email: true,
                    app: true,
                    type_id: setting.id
                };
            });
            await http('community/me/notification/store', {}, {
                token: 'Bearer ' + getCookie(TOKEN_CONGDONG),
                body: {types: body},
                method: 'POST'
            },
            'v2');

            resUser = await http('community/me/notification/settings', {}, { token: 'Bearer ' + getCookie(TOKEN_CONGDONG) }, 'v2');
        }

        setState({meSetting: resUser.data});
    };

    useEffect(() => {
        getAllSetting();
    }, []);

    useEffect(() => {
        if(isEmpty(state.allSetting)) return;
        getMeSetting();
    }, [state.allSetting]);

    const switchProp = {
        onColor: "#34BEEF",
        height: 28,
        width: 48,
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.6)",
        activeBoxShadow: "0px 0px 1px 10px rgba(0, 0, 0, 0.2)",
        uncheckedIcon: false,
        checkedIcon: false,
        handleDiameter: 25
    };

    const onSwitch = async (id, currentState, all) => {
        setLoading(true);
        const body = state.allSetting.map(setting => {
            const result = {
                email: true,
                app: true,
                type_id: setting.id
            };
            const meSetting = state.meSetting.find(x => x.notification_type.id == setting.id);
            result.email = meSetting.email;
            result.app = meSetting.app;

            if (setting.id == id) {
                result.email = !currentState;
                result.app = !currentState;
            }
            return result;
        });

        await http('community/me/notification/store', {}, {
            token: 'Bearer ' + getCookie(TOKEN_CONGDONG),
            body: {types: body},
            method: 'POST'
        },
        'v2');
        await getMeSetting();
        setLoading(false);
    };

    const onSwitchAll = async () => {
        setLoading(true);
        const body = state.allSetting.map(setting => {
            const result = {
                email: true,
                app: true,
                type_id: setting.id
            };
            
            if(state.meSetting.some(x => x.app == true)) {
                result.email = false;
                result.app = false;
            } else {
                result.email = true;
                result.app = true;
            }
            return result;
        });

        await http('community/me/notification/store', {}, {
            token: 'Bearer ' + getCookie(TOKEN_CONGDONG),
            body: {types: body},
            method: 'POST'
        },
        'v2');
        await getMeSetting();
        setLoading(false);
    };

    return (
        <div className="manager-notif">
            <Loader loading={loading} />
            <div className="group-notif">
                <div className="items-notif">
                    <span className="notif-title">Nhận thông báo</span>
                    <div className="switch switch--notif">
                        <label className="switch-label">
                            <input className="switch-checkbox" checked="" value="on" type="checkbox" />
                            <Switch {...switchProp} onChange={() => onSwitchAll()} checked={state.meSetting.some(x => x.app == true)} />
                        </label>
                    </div>
                </div>
            </div>
            {/* <div className="group-notif">
                <h3 className="group-title">Thông báo sự kiện, lợi ích</h3>
                <p className="text">Đừng bỏ lỡ các sự kiện, khuyến mại và các thông tin quan trọng khác. Đặt thông báo nhận tin ngay!</p>
                <div className="items-notif">
                    <span className="notif-title">E-mail</span>
                    <div className="switch switch--notif">
                        <label className="switch-label">
                            <input className="switch-checkbox" checked="" value="on" type="checkbox" />
                            <Switch {...switchProp} onChange={() => { setState({ announcementEventsBenefits: !state.announcementEventsBenefits }); }} checked={state.announcementEventsBenefits} />
                        </label>
                    </div>
                </div>
                <div className="items-notif">
                    <span className="notif-title">Qua ứng dụng</span>
                    <div className="switch switch--notif">
                        <label className="switch-label">
                            <input className="switch-checkbox" checked="" value="on" type="checkbox" />
                            <Switch {...switchProp} onChange={() => { setState({ viaApp: !state.viaApp }); }} checked={state.viaApp} />
                        </label>
                    </div>
                </div>
            </div> */}
            <div className="group-notif">
                <h3 className="group-title">Thông báo dịch vụ</h3>
                <p className="text">Chúng tôi sẽ thông báo cho bạn về những thông tin, nội dung liên quan đến Cộng đồng</p>
                {
                    state.meSetting.map((setting, index) => {
                        return (<div key={index} className="items-notif">
                            <span className="notif-title">{setting.notification_type.name}
                                {/* {
                                    (setting.notification_type.id === 1 || setting.notification_type.code === 'FleaMarket') && <>
                                        <div className="select-receive">
                                            <button data-toggle="modal" data-target=".modal-receive" className="text mb-1">
                                                Chọn loại đồ cũ bạn muốn nhận
                                                <span className="arrow"><img src="/images/icon-arrow-listNav-active.svg" alt="" /></span>
                                            </button>
                                        </div>
                                        <ul className="receive-checked">
                                            <li>Ngoại thất</li>
                                            <li>Thiết bị đèn</li>
                                            <li>Đồ dùng bếp</li>
                                            <li>Nội thất</li>
                                            <li>Đồ dùng bếp</li>
                                        </ul>
                                    </>
                                } */}
                            </span>
                            <div className="switch switch--notif">
                                <label className="switch-label">
                                    <input className="switch-checkbox" checked="" value={setting.app} type="checkbox" />
                                    <Switch {...switchProp} onChange={() => onSwitch(setting.notification_type.id, setting.app)} checked={setting.app} />
                                </label>
                            </div>
                        </div>);
                    })
                }
            </div>
        </div>
    );
}